
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown } from "lucide-react";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import ComboMealListTable from "./combo-meal-list-table";
import Paginat from "@/components/lib/paginat";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useSelector } from "react-redux";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";

function ComboMealListTabs() {
  const { comboMeals } = useSelector((state) => state.menuManage.comboMeal);
 
  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(comboMeals, filters, {
    delay: 300,
    defaultFilter: (item) =>
      item.status !== "draft" &&
      (filters.status === "archived" ? item.status === "archived" : item.status !== "archived"),
  });

  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="drink">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="w-[260px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
          </div>
          <div className="flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              {/* <Select>
                <SelectTrigger className="w-[100px]">
                  <SelectValue placeholder="Day" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="20">Monday</SelectItem>
                    <SelectItem value="50">Tuesday</SelectItem>
                    <SelectItem value="20">Wednesday</SelectItem>
                    <SelectItem value="50">Thursday</SelectItem>
                    <SelectItem value="20">Friday</SelectItem>
                    <SelectItem value="50">Saturday</SelectItem>
                    <SelectItem value="50">Sunday</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select> */}
              <div className="relative">
                <Select
                  onValueChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: value === "0" ? "" : value,
                    }))
                  }
                >
                  <SelectTrigger className="w-[100px]">
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0">All</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="inactive">Inactive</SelectItem>
                    <SelectItem value="archived">Archived</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown size={18} /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <ComboMealListTable comboMeals={paginatedData} />
        </div>
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default ComboMealListTabs;
